import DateTimePickerField from "./DateTimePickerField"
import InputField from "./InputField"
import { Dictionary } from "../../interfaces/IAlert";
import HourMinuteInputFields from "./HourMinuteInputFields";
import { EditableFieldsDate, EditableFieldsString } from "../../interfaces/IFields";

interface EditableFieldsProps {
    editableFields: Dictionary<Date | string>;
    onReplaceContentText: (key: string, value: Date | string) => void;
}

function EditableFields({ editableFields, onReplaceContentText }: EditableFieldsProps) {
    return (
        <>
            {editableFields?.[EditableFieldsDate.startTimeDate] !== undefined && (
                <DateTimePickerField
                    name={EditableFieldsDate.startTimeDate}
                    title={`Starttid (${EditableFieldsDate.startTimeDate})`}
                    value={editableFields?.[EditableFieldsDate.startTimeDate] ? new Date(editableFields?.[EditableFieldsDate.startTimeDate]) : null}
                    required={true}
                    onChange={(date: Date) =>
                        onReplaceContentText(EditableFieldsDate.startTimeDate, date)
                    }
                />
            )}
            {editableFields?.[EditableFieldsDate.endTimeDate] !== undefined && (
                <DateTimePickerField
                    name={EditableFieldsDate.endTimeDate}
                    title={`Sluttid (${EditableFieldsDate.endTimeDate})`}
                    value={editableFields?.[EditableFieldsDate.endTimeDate] ? new Date(editableFields?.[EditableFieldsDate.endTimeDate]) : null}
                    required={true}
                    onChange={(date: Date) =>
                        onReplaceContentText(EditableFieldsDate.endTimeDate, date)
                    }
                />
            )}
            {editableFields?.[EditableFieldsString.startTimeFree] !== undefined && (
                <InputField
                    name={EditableFieldsString.startTimeFree}
                    title={`Starttid (${EditableFieldsString.startTimeFree})`}
                    value={editableFields?.[EditableFieldsString.startTimeFree] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.startTimeFree, e.target.value)
                    }
                    maxLength={10}
                />
            )}
            {editableFields?.[EditableFieldsString.endTimeFree] !== undefined && (
                <InputField
                    name={EditableFieldsString.endTimeFree}
                    title={`Sluttid (${EditableFieldsString.endTimeFree})`}
                    value={editableFields?.[EditableFieldsString.endTimeFree] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.endTimeFree, e.target.value)
                    }
                    maxLength={10}
                />
            )}
            {editableFields?.[EditableFieldsDate.solvedWithinDate] !== undefined && (
                <DateTimePickerField
                    name={EditableFieldsDate.solvedWithinDate}
                    title={`Rettet innen (${EditableFieldsDate.solvedWithinDate})`}
                    value={editableFields?.[EditableFieldsDate.solvedWithinDate] ? new Date(editableFields?.[EditableFieldsDate.solvedWithinDate]) : null}
                    required={true}
                    onChange={(date: Date) =>
                        onReplaceContentText(EditableFieldsDate.solvedWithinDate, date)
                    }
                />
            )}
            {editableFields?.[EditableFieldsDate.nextFollowupDate] !== undefined && (
                <DateTimePickerField
                    name={EditableFieldsDate.nextFollowupDate}
                    title={`Neste oppdatering (${EditableFieldsDate.nextFollowupDate})`}
                    value={editableFields?.[EditableFieldsDate.nextFollowupDate] ? new Date(editableFields?.[EditableFieldsDate.nextFollowupDate]) : null}
                    required={true}
                    onChange={(date: Date) =>
                        onReplaceContentText(EditableFieldsDate.nextFollowupDate, date)
                    }
                />
            )}
            
            {editableFields?.[EditableFieldsString.downTime] !== undefined && (
                <HourMinuteInputFields
                    name={EditableFieldsString.downTime}
                    title={`Estimert nedetid (${EditableFieldsString.downTime})`}
                    size="medium"
                    value={editableFields?.[EditableFieldsString.downTime] as string}
                    onChange={(newValue) =>
                        onReplaceContentText(EditableFieldsString.downTime, newValue)
                    }
                />
            )}
            {editableFields?.[EditableFieldsString.affectedServices] !== undefined && (
                <InputField
                    name={EditableFieldsString.affectedServices}
                    title={`Berørte tjenester (${EditableFieldsString.affectedServices})`}
                    placeholder="Tv, internett, telefon"
                    value={editableFields?.[EditableFieldsString.affectedServices] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.affectedServices, e.target.value)
                    }
                    maxLength={25}
                />
            )}
            {editableFields?.[EditableFieldsString.customerName] !== undefined && (
                <InputField
                    name={EditableFieldsString.customerName}
                    title={`Kundenavn (${EditableFieldsString.customerName})`}
                    value={editableFields?.[EditableFieldsString.customerName] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.customerName, e.target.value)
                    }
                    maxLength={30}
                />
            )}
            {editableFields?.[EditableFieldsString.customerAddress] !== undefined && (
                <InputField
                    name={EditableFieldsString.customerAddress}
                    title={`Adresse (${EditableFieldsString.customerAddress})`}
                    value={editableFields?.[EditableFieldsString.customerAddress] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.customerAddress, e.target.value)
                    }
                    maxLength={30}
                />
            )}
            {editableFields?.[EditableFieldsString.article] !== undefined && (
                <InputField
                    name={EditableFieldsString.article}
                    title={`Artikkel (${EditableFieldsString.article})`}
                    value={editableFields?.[EditableFieldsString.article] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.article, e.target.value)
                    }
                    maxLength={30}
                />
            )}
            {editableFields?.[EditableFieldsString.connectionNumber] !== undefined && (
                <InputField
                    name={EditableFieldsString.connectionNumber}
                    title={`Sambandsnummer (${EditableFieldsString.connectionNumber})`}
                    value={editableFields?.[EditableFieldsString.connectionNumber] as string}
                    required={true}
                    onChange={(e: any) =>
                        onReplaceContentText(EditableFieldsString.connectionNumber, e.target.value)
                    }
                    maxLength={30}
                />
            )}
        </>
    )
}

export default EditableFields;